import { render } from "./ModalReconheceDisabled.vue?vue&type=template&id=6180af12"
import script from "./ModalReconheceDisabled.vue?vue&type=script&lang=js"
export * from "./ModalReconheceDisabled.vue?vue&type=script&lang=js"
script.render = render

export default script